import React from 'react';
import { Modal } from '@spotify-internal/anchor-ds';
import { paths } from 'client/shared/Paths';
import { ButtonPrimary } from '@spotify-internal/encore-web';
import { useT } from 'client/i18n/hooks/useT';

const NoTaxiDistributionErrorModal = ({
  onClickClose,
}: {
  onClickClose: () => void;
}) => {
  const t = useT();
  return (
    <Modal
      isShowing
      isShowingCloseButton
      onClose={onClickClose}
      aria-labelledby="no-taxi-distribution-error-modal-title"
    >
      <Modal.Title id="no-taxi-distribution-error-modal-title">
        {t(
          'EpisodeEditorPublish.NoTaxiDistributionErrorModal.Title',
          'This feature is unavailable',
          'Distribution error modal title'
        )}
      </Modal.Title>
      <Modal.Body>
        {t(
          'EpisodeEditorPublish.NoTaxiDistributionErrorModal.Message',
          'To unlock this feature, contact support.',
          'Distribution error modal message'
        )}
      </Modal.Body>
      <Modal.Footer>
        <ButtonPrimary
          href={`${paths.getHelpPage(
            'newRequest'
          )}?ticket_form_id=360000826772`}
          kind="link"
          target="_blank"
        >
          {t(
            'EpisodeEditorPublish.NoTaxiDistributionErrorModal.ContactSupportLinkText',
            'Contact Support',
            'Contact Support link text'
          )}
        </ButtonPrimary>
      </Modal.Footer>
    </Modal>
  );
};

export { NoTaxiDistributionErrorModal };
